module.exports = __webpack_public_path__ + "media/images/gallery/ss_off-d083bd4a1e06b545cb40b635534ebae7.gif";